import graphql from "babel-plugin-relay/macro";
import React, { Suspense, useEffect } from "react";
import { useQueryLoader } from "react-relay";

import { Loader } from "@whoosh/design-system/src/components/display";

import { EventCardPairingsInner } from "./EventCardPairingsInner";
import type { EventCardPairingsQuery as EventCardPairingsQueryType } from "./__generated__/EventCardPairingsQuery.graphql";

export type EventCardPairingsProps = {
  eventSessionId: string;
};

export const EventCardPairings = ({
  eventSessionId,
}: EventCardPairingsProps) => {
  const [queryRef, loadQuery] = useQueryLoader<EventCardPairingsQueryType>(
    EventCardPairingsQuery
  );

  useEffect(() => {
    loadQuery({ eventSessionId });
  }, [eventSessionId, loadQuery]);

  return (
    <Suspense fallback={<Loader />}>
      {queryRef ? <EventCardPairingsInner queryRef={queryRef} /> : <Loader />}
    </Suspense>
  );
};

export const EventCardPairingsQuery = graphql`
  query EventCardPairingsQuery($eventSessionId: ID!) {
    session {
      currentClientProfile {
        member {
          ... on Member {
            id
          }
        }
      }
    }
    node(id: $eventSessionId) {
      __typename
      ... on EventSession {
        courses {
          count
        }
        bookings(first: 500) {
          edges {
            node {
              __typename
              ... on StandardBooking {
                startSlot {
                  ... on TimeSlot {
                    time
                    course {
                      name
                    }
                  }
                }
                rounds(first: 50) {
                  edges {
                    node {
                      __typename
                      player {
                        id
                        firstName
                        lastName
                      }
                      transportationType {
                        id
                        name
                        code
                      }
                      courseLayout {
                        id
                        name
                        holeCount
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
